import { Toast } from 'mint-ui';
var root="/api/proxy/index";
//获取导航参数
function geturl_j1(name){
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}
window.UPLOAD_URL="";
//var root="apis/"
var axios = require('axios');
var axiosApi=(type,url,params,success,fail)=>{
  //去掉参数中的表情
  var reg=/[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;
  params.v_key = geturl_j1('v_key')
  for(var i in params){
    //这些字段没有必要检验
    if(i!=="api" && i!=="user_type" && i!=="page" && i!=="len"){
      if(reg.test(params[i])){
        params[i]=params[i].replace(reg,"")
      }
    }
  }
  var axiosObj=axios.create({
		url:url,
		baseURL:root,
		methods:type,
		params:type=="GET"?params:null,
		data:type=="POST"?params:null
	});
  axiosObj.interceptors.request.use(function (config) {
    // console.log("ajax之前");
    return config;
  });
  return axiosObj.request().then((res)=>{
		console.log(res.data);
		if(res.data.status===1){
			if(success) success(res.data);
		}
		else{
			if(fail){
				fail(res.data);
			}
			else{
				var message=res.data.msg;
				message=message || "未知错误";
				if(message == '尚未开通' || message.indexOf('无法更新视频') != -1 || message.indexOf('令牌') != -1){
          return
        }
        if(message == '姓名不一致'){
          Toast('用户已存在，请直接登录')
          return
        }
        if(message != '未报名'){
          Toast(message);
        }
			}
		}
	})
}
export default{
  //现在axiosApi直接执行并返回一个promise实例
  //如果返回一个实例
	get(url,params,success,fail){
		return axiosApi("GET",url,params,success,fail);
	},
	post(url,params,success,fail){
		return axiosApi("POST",url,params,success,fail);
	}
}



// WEBPACK FOOTER //
// ./src/api/index.js